<template>
  <div name="customUnit" class="inner">
    <innertopbar @close="closeWindow()">
      <template v-slot:breadcrumb>
        <router-link to="my-content"> Units </router-link>
        <i class="carret fas fa-caret-right"></i> {{ subject.title }}
        <i class="carret fas fa-caret-right"></i> {{ unitTitle }}
        <i class="carret fas fa-caret-right"></i> {{ title }}
      </template>

      <template v-slot:listitems>
        <li
          v-if="course.id != undefined"
          @click="addNewLessson()"
          v-tooltip="{
            content: 'Add new Lesson',
            placement: 'bottom-center',
            offset: 5,
            classes: ['tooltip-info'],
          }"
          class="action-list-item inline-block p-2 bg-list-grey hover:opacity-100"
        >
          <i class="fas fa-plus" title="Add Lesson"></i>
        </li>

        <li
        v-if="showDelete"
          @click="deletion"
          v-tooltip="{
            content: 'Delete',
            placement: 'bottom-center',
            offset: 5,
            classes: ['tooltip-info'],
          }"
          title="Delete"
          class="action-list-item pt-1 inline-block bg-list-grey hover:opacity-100"
        >
          <i class="icon fas fa-trash-alt" title="Delete"></i>
        </li>
      </template>
    </innertopbar>

    <div class="w-full bg-white mt-1 mb-4 ">
      <ul class="w-full flex overflow-y-scroll px-2" ref="navList">
        <li
          v-bind:class="unitInEdit == true ? 'bg-gray-200 ' : 'bg-list-grey'"
          @click="editDetails"
          class="
            group
            p-3
            py-5
            font-medium
            hover:bg-gray-200
            cursor-pointer
            text-sm text-base-text
            border
            border-gray-100
            min-w-min
            font-bold
            flex-shrink-0
          "
        >
            Unit Details
        </li>

        <li
          v-for="item in orderedLessons"
          :key="item.id"
          v-bind:class="lessonIsSelected(item) ? 'bg-gray-200' : 'bg-white'"
          class="
            group
            p-3
            py-5
            align-bottom
            font-medium
            hover:bg-gray-200
            hover:opacity-75
            cursor-pointer
            text-sm text-base-text
            border
            border-gray-100

            flex-shrink-0
          "
          @click="editLesson(item)"
        >


          <div class="align-bottom block">

        <span class="rounded p-1 px-2 rounded-full  mr-1 text-white font-bold group-hover:opacity-75 text-xs"
                          v-bind:class="lessonIsSelected(item) ? 'bg-action-blue' : 'bg-gray-300'">{{item.order}}</span>

            {{ item.name }}
          </div>
        </li>
      </ul>

    </div>

    <div class="w-full mx-auto mt-4 mb-10">
      
      <div v-if="componentLoaded">
        <unitEdit
          :course="course"
          :cats="filteredCats"
          :years="years"
          v-show="unitInEdit"
          :key="course.id"
          @append="courseAdded"

        ></unitEdit>


        <lessonEdit
          v-show="selectedLesson != null"
          v-if="selectedLesson != null"
          :course="course"
          :lesson="selectedLesson"
          @append="updateLessons"
          :key="selectedLesson.id"
        ></lessonEdit> 

  
      </div>

    </div>

    <div class="custom-unit tab" v-if="2 == 3">
      <button
        class="tablinks"
        v-if="currentUser.isOrganisation"
        v-bind:class="checkTab(3)"
        v-on:click="showSchools()"
      >
        <i class="icon fas fa-school"></i>
        Schools
      </button>
    </div>

    <div class="tabcontent" v-show="isSelectedContent(3)" v-if="2 == 3">
      <schoolapply :course="course" ref="schoolApply"></schoolapply>
    </div>

    <lessonAdd
      @close="lessonAdditionComplete"
      :lesson="newLesson"
      :course="course"
      v-if="showLessonAddModal"
    ></lessonAdd>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { yearGroupMixin } from "@/mixins/yearGroupMixin.js";

import { SchoolService, BaseService } from "@/services/school.service";
const lessonEdit = () => import("@/components/customunit/TheLessonEdit.vue");
const lessonAdd = () => import("@/components/customunit/TheLessonAdd.vue");
const unitEdit = () => import("@/components/customunit/TheUnitEdit.vue");
const schoolapply = () => import("@/components/customunit/SchoolApply.vue");

const innertopbar = () => import("@/components/InnerTopBar.vue");

export default {
  name: "customUnit",
  mixins: [yearGroupMixin],
  props: {
    cats: { type: Array, required: false },
    subject:  { type: Object, required: false },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    componentLoaded() {
      return this.years.length > 0 && this.catsList.length > 0;
    },
    showOutcomes() {
      return (
        this.currentAccess.outcomeAccess &&
        this.displayLessonCount > 0 &&
        this.selectedLesson == null
      );
    },
    showDelete() {
      return this.newAddition === false
    },
    lessonHead() {
      return this.lessons.length === 0 ? "No lessons available" : "Lessons";
    },
    displayLessonCount() {
      return this.lessons.length == undefined ? 0 : this.lessons.length;
    },
    orderedLessons() {
      return _.orderBy(this.lessons, ["order", "name"]);
    },
    newAddition() {
      var c = this.course;
      return c.id === undefined;
    },
    unitTitle() {
      return this.course.name == undefined ? "New Unit" : this.course.name;
    },
    title() {
      if (this.unitInEdit) {
        return "Details";
      } else {
        return this.selectedLesson.id == undefined
          ? "New Lesson"
          : this.selectedLesson.name;
      }
    },
    isOverflowing() {
      return this.lessons.length > 9
      // if (this.element != undefined) {
      //   console.log(this.element.scrollLeftMax)

      //   console.log(this.element)
      //   return (this.element.offsetWidth < this.element.scrollWidth)
      // }
    },
    filteredCats() {
      if (this.subject.id === 1) {
        return this.catsList
      } else {
        return this.catsList
      }
    }
  },
  data() {
    return {
      errored: false,
      unitInEdit: true,
      course: this.$store.getters.unit,
      lessons: [],
      trigger: 0,
      isDisabled: false, //this.course.id === undefined ? true : false,
      name: "ssss", //this.course.id === undefined ? "New Unit" : this.course.name,
      selectedLesson: null,
      catsList: [],
      showLessonAddModal: false,
      newLesson: {},
      element: undefined
    };
  },
  // watch: {
  //   element: function () {
  //     console.log("Prop changed: ");
  //      console.log("LOAD", this.element.scrollLeftMax)
  //   },
  // },
  mounted() {

  },
  created() {
    console.log("initial course id" & this.courseId);
    if (this.course.id != undefined) {
      this.fetchData();
    } else {
      this.course.subject_id = this.subject.id
    }

    if (this.cats === undefined) {
      BaseService.getAll("categories")
        .then((response) => this.buildCategoryList(response.data.data))
        .catch((res) => {
          console.log(res);
        });
    } else {
      this.catsList = this.cats;
    }
  },
  methods: {
    fetchData() {
      SchoolService.getAll("courses/" + this.course.id + "/lessons")
        .then((response) => this.buildLessonList(response.data.data))
        .catch((err) => {
          console.log("Lessons " + err);
          //this.addNew();
        });
    },
    buildLessonList(data) {
    
      this.lessons = data;
      this.element = this.$refs.navList;
    
    },
    buildCategoryList(data) {
      this.catsList = data;
    },
    setToolTipStyle() {
      return "rounded bg-" + this.currentUser.schoolBackground;
    },
    lessonIsSelected(lesson) {
      if (this.selectedLesson == null) {
        return false;
      }

      return this.selectedLesson.id == lesson.id;
    },
    editLesson(lesson) {
      this.selectedLesson = lesson;
      this.unitInEdit = false;
    },
    editDetails() {
      this.unitInEdit = true;
      this.selectedLesson = null;
    },
    courseAdded(val) {
      this.course = this.course;
      this.course.id = val;
      this.trigger += 1;
    },
    addNewLessson() {
      this.newLesson = {
        id: undefined,
        name: "",
        outline:  "",
        equipment: "",
        maincontent: "",
        document_url: "",
        warmup: "",
        gamecontent: "",
        health: "",
        performance:"",
        competition: "",
        conclusion: "",
        location: "",
        introduction: "",
        collaboration: "",
        activities: "",
        active: 1,
        layout: "file",
        course_id: this.course.id,
        order: this.lessons.length + 1,
      };
      this.showLessonAddModal = true;
    },
    lessonAdditionComplete() {
      this.showLessonAddModal = false;
      this.updateLessons(true);
    },
    updateLessons(reload) {
      if (reload) {
        this.fetchData();
        this.editDetails();
      }
    },
    closeWindow() {
      this.$router.push({ path: "/my-content" });
      window.scrollTo(0, 0);
    },
    deletion() {
      let title = this.unitInEdit ? "Course" : "Lesson"

      this.$swal({
        title: "Delete " + title + " - Are you sure",
        text: "You have selected to delete this " + title,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, continue to delete",
        cancelButtonText: "No, cancel",
        showCloseButton: false,
        showLoaderOnConfirm: true,
      }).then((result) => {
        console.log("SDErrrr", result);
        if (result.isConfirmed === true) {
          this.confirmDelete(this.course.id);
        }
      });
    },
    confirmDelete(val) {
      if (this.unitEdit) {
        SchoolService.delete("courses", val)
        .then((response) => this.refreshUnits())
        .catch((err) => {
          console.log("Course delete error " + err);
        });
      } else if (this.selectedLesson != null) {
        SchoolService.delete("lessons", this.selectedLesson.id)
        .then((response) => this.fetchData())
        .catch((err) => {
          console.log("Course delete error " + err);
        });
      }

    },
    refreshUnits() {
      this.closeWindow();
    },
  },
  components: {
    unitEdit,
    lessonEdit,
    lessonAdd,
    schoolapply,
    innertopbar,
  },
};
</script>


<style>
</style>
